module.exports.web=require("./web");
module.exports.cli=require("./cli");